// react
import { useEffect, useState } from "react";

// kendo
import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { Window } from '@progress/kendo-react-dialogs';

// css
import styles from './elderLog.module.css';

// service
import { gathDataExcelDownLoad } from "../../../service/log/elderLogService";
import { numFormat, roundNum } from "../../../com/dataUtil";
import { getFile, setUserPhoto } from "../../../service/mngt/elderService";

// import styles from './'

const ElderLogDashboard = ({ conn, dataSource, page, setPageValue, search, infoEventWindow, setInfoEventWindow, setLoading, userStat }) => {

  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: "",
    imgFilePlacePhoto1: "",
    imgFilePlacePhoto2: "",
    imgFilePlacePhoto3: "",
  });

  const [placePhotoVisible, setPlacePhotoVisible] = useState(false);
  const [placePhotoNum, setPlacePhotoNum] = useState(1);

  const alertWindowWidth = 632;
  const alertWindowHeight = 560;
  const innerWidth = window.innerWidth - 20;
  const innerHeight = window.innerHeight - 20;
  const closeEvt = () => {
    setPlacePhotoVisible(false);
  }

  const userPhoto = () => {
    if(userStat.fileIdUserPhoto) {
      getFile(conn, userStat.fileIdUserPhoto)
      .then(fileResponse => {
        const dataUri = 'data:image/png;base64,' + fileResponse;
        setImgFile((imgFile) => {
          const item = { ...imgFile};
          item.imgFileUserPhoto = dataUri;
          return item;
        });
      })
      .catch(err => {
        console.log("getFile err = ", err);
      })
    }
    if(userStat.fileIdPlacePhoto1) {
      getFile(conn, userStat.fileIdPlacePhoto1)
      .then(fileResponse => {
        const dataUri = 'data:image/png;base64,' + fileResponse;
        setImgFile((imgFile) => {
          const item = { ...imgFile};
          item.imgFilePlacePhoto1 = dataUri;
          return item;
        });
      })
      .catch(err => {
        console.log("getFile err = ", err);
      })
    } 
    if(userStat.fileIdPlacePhoto2) {
      getFile(conn, userStat.fileIdPlacePhoto2)
      .then(fileResponse => {
        const dataUri = 'data:image/png;base64,' + fileResponse;
        setImgFile((imgFile) => {
          const item = { ...imgFile};
          item.imgFilePlacePhoto2 = dataUri;
          return item;
        });
      })
      .catch(err => {
        console.log("getFile err = ", err);
      })
    } 
  }
  const genderImg = () => {
    if(userStat.userGender === "M") {
      return <img className={styles.genderImg} src="/images/mobile/icon_man.png"/>;
    } else if (userStat.userGender === "W") {
      return <img className={styles.genderImg} src="/images/mobile/icon_woman2.png"/>;
    } else {
      return null;
    }
  }

  const statTime = () => {
    let text = "미작동"
    let hour;
    let min;

    if(userStat.latestDataStatTime) {
      hour = parseInt(userStat.latestDataStatTime/60)
      min = userStat.latestDataStatTime%60

      text = hour + "시간 " + min + "분"
    } else if (userStat.meainStatCode == '20005') {
      text = "설치예정"
    }
    return text;
  }

  // 설비 상태 이미지
  const eventImg = () => {
    if ( userStat.meainStatCode === "20001" ) {
      return <img className={styles.eventImg} id="userNormal" src="/images/mobile/normal2.png"/>
    } else if ( userStat.meainStatCode === "20002" ) {
      return <img className={styles.eventImg}id="userWarn" src="/images/mobile/warn2.png"/>
    } else if ( userStat.meainStatCode === "20003" ) {
      return ;
    } else if ( userStat.meainStatCode === "20004" ) {
      return <img className={styles.eventImg} id="userDanger" src="/images/mobile/danger2.png"/>
    } else {
      return ;
    }
  }

  // 유저 상태 이미지
  const statImg = () => {
    if ( userStat.dataStatTerm === '고활동' ) {
      return <img className={styles.stateImg} src="/images/mobile/high_activity.png"/>
    } else if ( userStat.dataStatTerm === '저활동' ) {
      return <img className={styles.stateImg} src="/images/mobile/low_activity.png"/>
    } else if ( userStat.dataStatTerm === '식사' ) {
      return <img className={styles.stateImg} src="/images/mobile/meal.png"/>
    } else if ( userStat.dataStatTerm === '수면' ) {
      return <img className={styles.stateImg} src="/images/mobile/sleep.png"/>
    } else if ( userStat.dataStatTerm === '수면불안' ) {
      return <img className={styles.stateImg} src="/images/mobile/sleep.png"/>
    } else if ( userStat.dataStatTerm === '자리비움' ) {
      if(userStat.latestDataStatTime < 60) {
        return <img className={styles.stateImg} src="/images/mobile/out.png"/>
      } else {
        return <img className={styles.stateImg} src="/images/mobile/out.png"/>
      }      
    } else {
      return <img className={styles.stateImg} src="/images/mobile/off2.png"/>
    }
  }

  // 현장사진 open
  const openPlacePhoto = () => {
    setPlacePhotoNum(1);
    setPlacePhotoVisible(true);
  }

  const changePlacePhoto = (e) => {
    if(e.target.id === "placePhoto1") {
      setPlacePhotoNum(1);
    } else if(e.target.id === "placePhoto2") {
      setPlacePhotoNum(2);
    }
  }

  useEffect(() => {
    userPhoto();
  }, [userStat])
  // console.log("search = ", search);
  return (
    <div className={styles.elderLogDashboard}>
      {Object.keys(userStat).length === 0 ?
      <div className={styles.noData}>
        대상자를 선택해주세요.
      </div>
      :
      <div className={styles.elderLogWhole}>
        <div className={styles.elderLogUser}>
          <div className={styles.elderLogUserTop}>
            {userStat.fileIdUserPhoto ?
              <img className={styles.userPhoto} src={imgFile.imgFileUserPhoto} alt="사진" />
              :
              <img className={styles.userPhoto} src="/images/mobile/photo.png" alt="사진" />
            }
          </div>
          <div className={styles.elderLogUserBottom}>
            <span className={styles.userName}>
              <b>{userStat.userTerm ? userStat.userTerm : "이름"}({userStat.dongTermSimple ? userStat.dongTermSimple : "읍면동"})</b>
            </span>
            <span className={styles.userBirthday}>
              <b>{userStat.birthday ? userStat.birthday : "생년월일"}</b>
              {genderImg()}
            </span>
          </div>
        </div>
        <div className={styles.elderLogState}>
          <div className={styles.elderLogStateTop}>
            <span className={styles.state}>
              {userStat.dataStatTerm} 상태
            </span>
            <br/>
            <span className={styles.stateTime}>
              {statTime()}
            </span> 
            <span className={styles.state}>
              입니다.
            </span>
            <br/>
          </div>
          <div className={styles.elderLogStateBottom}>
            {eventImg()}
            {statImg()}

          </div>
        </div>
        <div className={styles.elderLogInfo}>
          <div className={styles.elderLogInfoBoxA}>
            <div className={styles.boxAHeader}>
              상세주소
            </div>
            <div className={styles.boxABody}>
              <div className={styles.adress}>{userStat.dongTerm ? userStat.dongTerm : "주소"}</div>
              <div className={styles.adress}>{userStat.address ? userStat.address : ""}</div>
              <button onClick={openPlacePhoto}>현장사진</button>
            </div>
          </div>
          <div className={styles.elderLogInfoBoxB}>
            <div className={styles.boxTop}>
              <div className={styles.boxAHeader}>
                대상자 연락처
              </div>
              <div className={styles.boxBBody}>
                <div>{userStat.userPhone ? userStat.userPhone : "-"}</div>
              </div>
            </div>
            <div className={styles.boxBottom}>
              <div className={styles.boxAHeader}>
                위험 대상자 / 장기부재 대상자
              </div>
              <div className={styles.boxBBody}>
                <div>
                  {userStat.dangerYn === "Y" ? "해당" : "해당없음"} / {userStat.absenceYn === "Y" ? "해당" : "해당없음"}
                  {/* <button className={styles.settingBtn}>설정</button> */}
                  </div>
              </div>
            </div>
          </div>
          <div className={styles.elderLogInfoBoxB}>
            <div className={styles.boxTop}>
              <div className={styles.boxAHeader}>
                보호자 연락처
              </div>
              <div className={styles.boxBBody}>
                <div>{userStat.protectorPhone ? userStat.protectorPhone : "-"}</div>
              </div>
            </div>
            <div className={styles.boxBottom}>
              <div className={styles.boxAHeader}>
                거주 유형
              </div>
              <div className={styles.boxBBody}>
                <div>{userStat.liveType ? userStat.liveType : "-"}</div>
              </div>
            </div>
          </div>
          <div className={styles.elderLogInfoBoxA}>
            <div className={styles.boxAHeader}>
              보유 지병
            </div>
            <div className={styles.boxABody}>
              <div>{userStat.sickType ? userStat.sickType : "-"}</div>
            </div>
          </div>
          <div className={styles.elderLogInfoBoxA}>
            <div className={styles.boxAHeader}>
              특이사항
            </div>
            <div className={styles.boxABody}>
              <div>{userStat.note ? userStat.note : "-"}</div>
            </div>
          </div>
        </div>
      </div>
      }
      {placePhotoVisible && (
        <Window
          style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
          className="placePhotoWindow"
          title={"현장사진"}
          actions={['Close']}
          width={alertWindowWidth}
          height={alertWindowHeight}
          draggable={false}
          resizable={false}
          left={300}
          initialTop={200}
          onClose={closeEvt}>
            {placePhotoNum === 1 ?
              <div>
                {userStat.fileIdPlacePhoto1 ? <img className={styles.placePhoto} src={imgFile.imgFilePlacePhoto1} alt="사진" /> : <img className={styles.placePhoto} src="/images/mobile/noPlacePhoto.png" alt="사진" />}
              </div>
              : placePhotoNum === 2 ?
              <div>
                {userStat.fileIdPlacePhoto2 ? <img className={styles.placePhoto} src={imgFile.imgFilePlacePhoto2} alt="사진" /> : <img className={styles.placePhoto} src="/images/mobile/noPlacePhoto.png" alt="사진" />}
              </div>
              : null
            }
          <button id="placePhoto1" onClick={changePlacePhoto}>사진 1</button><button id="placePhoto2" onClick={changePlacePhoto}>사진 2</button>
        </Window>
      )}
    </div>
  );
};

export default ElderLogDashboard;
